import {mapState,mapMutations} from 'vuex'
import {showOverlay} from "../utils/showOverlay";

export const projectsView = {
  mixins: [showOverlay],
  computed: {
    ...mapState({
      activeView: state => state.projects.activeView
    }),
    isTile() {
      return this.activeView === 'tile'
    },
    isList() {
      return this.activeView === 'list'
    }
  },
  methods: {
    ...mapMutations({
      setActiveView: 'projects/SET_ACTIVE_VIEW',
      showCreateProject: 'projects/SET_SHOW_CREATE_PROJECT',
    })
  }
}
